import React, { useEffect, useState } from "react";
import Image from "../../../components/image/Image";
import SidebarModel from "../../../components/ui/sidebarModel/SidebarModel";
import { AppIcons } from "../../../data/appIcons";
import AddCandidate from "../../../features/hrManagement/component/AddUpdateCandidate/component/AddCandidate";
import "./AddCandidates.scss";
import { hasFunctionalPermission } from "../../../utils/authorizeNavigation/authorizeNavigation";
import { securityKey } from "../../../data/SecurityKey";

function AddCandidates(props) {
  const [isModelOpen, setisModelOpen] = useState(false);
  const [hasButtonPermission, setHasButtonPermission] = useState(false);
  const hasAddPermission = hasFunctionalPermission(securityKey.ADDCANDIDATE);
  // Function to handle closing the sidebar modal
  const onSidebarClose = () => {
    setisModelOpen(false);
  };
  const addCandidate = () => {
    setisModelOpen(!isModelOpen);
  };


  useEffect(() => {
    if (hasAddPermission?.hasAccess) {
      setHasButtonPermission(true);
    } else {
      setHasButtonPermission(false);
    }
  }, [hasAddPermission]);

  return (
    <div className="common-add-candidate-btn">
      {hasButtonPermission ?
       <button
        type="button"
        className="btn theme-btn add-candidate"
        onClick={addCandidate}
        title="Add Candidate"
       
      >
        <Image imagePath={AppIcons.userImg} altText="button Icon" />
        <Image imagePath={AppIcons.addIcon} altText="button Icon" />
      </button>: null}
      
      {/* Sidebar modal for adding/editing crafts */}
      
      <SidebarModel
        modalTitle="Add Candidate"
        modalSize="w-45"
        onClose={onSidebarClose}
        isOpen={isModelOpen}
      >
        <AddCandidate isOpen={isModelOpen} onClose={onSidebarClose} />
      </SidebarModel>
    </div>
  );
}

export default AddCandidates;
